import { SxProps, TypographyProps } from "@mui/material";
import muiVariables from "../../styles/mui-variables"

const CalenderStyle = {
  mainBoxStyle: {
    justifyContent: "center",
    alignItems: "center",
    padding: "20px 20px 0",
  } as SxProps,
  headerBoxStyle: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  } as SxProps,
  mainTitleTypo: {
    color: muiVariables.mainTextColor,
    fontFamily: muiVariables.mainFontFamily,
    fontSize: "20px",
    fontWeight: 700,
    lineHeight: "normal",
    fontStyle: "normal",
  } as TypographyProps,
  subTitleTypo: {
    color: muiVariables.subTextColor,
    fontFamily: muiVariables.mainFontFamily,
    fontSize: muiVariables.subHeadingFontSize,
    fontWeight: 500,
    lineHeight: "normal",
    fontStyle: "normal",
  } as TypographyProps,
  mainBtnSx: {
    backgroundColor: muiVariables.primaryBtnColor,
    borderColor: muiVariables.borderColor,
    color: `${muiVariables.primaryColor}`,
    ":hover": {
      backgroundColor: muiVariables.primaryBtnColor,
      borderColor: muiVariables.borderColor,
      color: `${muiVariables.primaryColor}`,
      boxShadow: "none",
    },
  } as SxProps,
  searchInputSx: {
    width: { sm: "262px" },
    "& .MuiInputBase-input": {
      background: `${muiVariables.primaryColor} !important`,
      fontSize: "14px",
      fontFamily: muiVariables.mainFontFamily,
      fontWeight: 400,
    },
    "& .MuiInputAdornment-root": {
      marginRight: "0px !important",
    },
    "& .MuiOutlinedInput-root": {
      alignItems: "baseline",
      border: `1px solid ${muiVariables.borderColor}`,
      borderRadius: "6px",
      paddingLeft: "16px !important",
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& .MuiSvgIcon-root": {
      height: "24px",
      width: "24px",
    },
    background: muiVariables.primaryColor,
    borderRadius: "6px",
    paddingRight: "10px"
  } as SxProps,
}

export default CalenderStyle